<template>
    <div class="text-left">
        <div v-if="errorMessage" class="alert alert-danger mt-2">
            {{ errorMessage }}
        </div>
        <div class="alert alert-success" v-if="copied">
            {{ $t('prepay_inviter.link_copied') }}
        </div>
        <copy-to-clipboard
            label="copy-invite"
            :text-to-copy="participant.prepay_invite_link"
            @copied="onCopy"
        ></copy-to-clipboard>

        <b-form-input class="mb-1" :placeholder="$t('prepay_inviter.email_placeholder')" v-validate="'email|required'" data-vv-scope="invite"
                      type="email" data-vv-as="email address" name="email" v-model="email"/>
        <div v-show="vErrors.has('invite.email')"
             class="text-danger mb-2">
            {{ vErrors.first('invite.email') }}
        </div>

        <b-form-input class="mb-1" :placeholder="$t('prepay_inviter.first_name_placeholder')" v-validate="'required'" data-vv-scope="invite"
                      name="firstName" data-vv-as="first name" type="text"
                      v-model="firstName"/>
        <div v-show="vErrors.has('invite.firstName')"
             class="text-danger mb-2">
            {{ vErrors.first('invite.firstName') }}
        </div>

        <b-form-input class="mb-1" :placeholder="$t('prepay_inviter.last_name_placeholder')" v-validate="'required'" data-vv-scope="invite"
                      name="lastName" data-vv-as="last name" type="text" v-model="lastName"/>
        <div v-show="vErrors.has('invite.lastName')"
             class="text-danger mb-2">
            {{ vErrors.first('invite.lastName') }}
        </div>

        <b-form-textarea
                id="textarea"
                max-rows="6"
                :placeholder="$t('prepay_inviter.message_placeholder')"
                rows="3"
                v-model="message"/>

        <b-button :class="btnClass" @click="sendInvite" block class="mt-2"
                  :variant="btn ? 'outline-primary' : 'success'"
                  :disabled="!btn || submitting">{{ btnText }}
        </b-button>
    </div>
</template>

<script>
    import axios from 'axios'
    import ApiErrorMixin from '../../mixins/ApiErrorMixin.js';
    import CopyToClipboard from "../Utility/Buttons/CopyToClipboard.vue";

    export default {
        name: "PrePayInviter",
        mixins: [ApiErrorMixin],
        props: {
            participant: {
                type: Object,
                required: true,
            }
        },
        components: {
            CopyToClipboard,
        },
        computed: {
            btnClass() {
                if (this.btn) {
                    return "btn-primary";
                }
                return "btn-success";
            },
            btnText() {
                if(this.submitting){
                    return this.$t('prepay_inviter.sending_invite');
                }

                return this.btn ? this.$t('prepay_inviter.send_invite') : this.$t('prepay_inviter.invite_sent');
            }
        },
        data() {
            return {
                email: '',
                firstName: '',
                lastName: '',
                message: '',
                btn: true, //If the button can be pressed,
                submitting: false,
                copied: false,
                errorMessage: '',
            }
        },
        created() {
            this.email = this.participant.email || '';
            this.firstName = this.participant.first_name || '';
            this.lastName = this.participant.last_name || '';
        },
        methods: {
            async sendInvite() {
                this.submitting = true;
                this.errorMessage = '';

                const result = await this.$validator.validateAll('invite');

                if (!result) {
                    this.submitting = false;
                    return;
                }

                try {
                    const response = await this.$root.makeApiRequest(async (jwtToken) => {
                        return await axios.post(
                            `/api/v0/participants/${this.participant.id}/prepay/invite`,
                            {
                                email: this.email,
                                first_name: this.firstName,
                                last_name: this.lastName,
                                message: this.message,
                            },
                            {
                                headers: {
                                    'Authorization': jwtToken,
                                    'Content-Type': 'application/json',
                                },
                            }
                        );
                    });

                    // The API returns HTTP 200 for some errors (JSend envelope), so axios won't throw.
                    // Check the response body explicitly before treating the request as successful.
                    if (response && response.data && response.data.status === 'error') {
                        this.submitting = false;
                        if (response.data.code === 403) {
                            this.errorMessage = this.$t('prepay_inviter.unauthorized_error');
                            return;
                        }
                        this.errorMessage = this.$t('prepay_inviter.generic_error');
                        return;
                    }

                    this.btn = false;
                    this.$root.$emit('bv::hide::modal', 'inviteModal' + this.participant.id);
                    window.location.reload(true);
                } catch (error) {
                    this.submitting = false;
                    if (this.isForbiddenError(error)) {
                        this.errorMessage = this.$t('prepay_inviter.unauthorized_error');
                        return;
                    }
                    this.errorMessage = this.$t('prepay_inviter.generic_error');
                }
            },
            onCopy() {
                this.copied = true;
                setInterval(() => {
                    this.copied = false;
                }, 4000)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/Assets/components/Participants/PrePayInviter.vue